var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColSmOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98618 0.287161H1.73336C1.03807 0.287161 0.474438 0.73866 0.474438 1.29561V17.7065C0.474438 18.2634 1.03807 18.7149 1.73336 18.7149H1.98618C2.68146 18.7149 3.2451 18.2634 3.2451 17.7065V1.29561C3.2451 0.73866 2.68146 0.287161 1.98618 0.287161Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColSmOwner);
export default __webpack_public_path__ + "static/media/col_sm_owner.421c966880871d943d624667d0921ec4.svg";
export { ForwardRef as ReactComponent };